export default __webpack_public_path__ + "static/media/btn-addmember-ic.720bdb14.svg";